module.exports = __webpack_public_path__ + "img/page-timer-black.b23eebec.png";